<template>
  <div class="block">
    
    <canvas id="canvas" ref="canvas" style="display: block; height: 150px; width: 300px;" width="100%" height="100%" class=""></canvas>

    <div class="row">
        <div>
          <router-link class="waves-effect waves-light btn grey left" :to="{ name: 'Athlete'}">Back
              <i class="material-icons right">subdirectory_arrow_left</i>
          </router-link>
        </div>
      </div>

</div>
</template>

<script>
import Chart from 'chart.js'
import moment from 'moment'
import api from '@/api'

export default {
  name: 'bodyLog',
  data: function () {
    return {
    }
  },
  mounted () {
    var user = api.getCurrentUser()
    var labels = []
    var values = []
    var logs = user.athlete.bodyLog
    for (var i in logs) {
      labels.push(moment(logs[i].dt))
      values.push(user.bodyFat(logs[i].weight, logs[i].waist))
    }
    var config = {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: '%body fat',
          backgroundColor: 'red',
          borderColor: 'red',
          fill: false,
          data: values
        }]
      },
      options: {
        title: {
          text: 'Body fat history'
        },
        scales: {
          xAxes: [{
            type: 'time',
            distribution: 'linear',
            time: {
              round: 'day',
              unit: 'day',
              parser: 'll',
              tooltipFormat: 'll HH:mm'
            },
            scaleLabel: {
              display: true,
              labelString: 'Date'

            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: '% of body mass'
            }
          }]
        }
      }
    }

    var ctx = this.$refs.canvas.getContext('2d')
    window.myLine = new Chart(ctx, config)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.block {
  margin-top: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/athlete/BodyLog.vue